// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { GroupControl } from "./group-control";
import { BoolValue, BoolValueT, verifyBoolValue } from "../value/bool-value";
import { ByteValue, ByteValueT, verifyByteValue } from "../value/byte-value";
import { DoubleValue, DoubleValueT, verifyDoubleValue } from "../value/double-value";
import { FloatValue, FloatValueT, verifyFloatValue } from "../value/float-value";
import { IntValue, IntValueT, verifyIntValue } from "../value/int-value";
import { LongValue, LongValueT, verifyLongValue } from "../value/long-value";
import { ShortValue, ShortValueT, verifyShortValue } from "../value/short-value";
import { StringValue, StringValueT, verifyStringValue } from "../value/string-value";
import { UByteValue, UByteValueT, verifyUByteValue } from "../value/ubyte-value";
import { UIntValue, UIntValueT, verifyUIntValue } from "../value/uint-value";
import { ULongValue, ULongValueT, verifyULongValue } from "../value/ulong-value";
import { UShortValue, UShortValueT, verifyUShortValue } from "../value/ushort-value";
import { Value, unionToValue, unionListToValue } from "../value/value";

export class ValuedGroupControl implements flatbuffers.IUnpackableObject<ValuedGroupControlT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ValuedGroupControl {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsValuedGroupControl(
    bb: flatbuffers.ByteBuffer,
    obj?: ValuedGroupControl,
  ): ValuedGroupControl {
    return (obj || new ValuedGroupControl()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsValuedGroupControl(
    bb: flatbuffers.ByteBuffer,
    obj?: ValuedGroupControl,
  ): ValuedGroupControl {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ValuedGroupControl()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  message(): GroupControl {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : GroupControl.SEC;
  }

  valueType(): Value {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Value.NONE;
  }

  value<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startValuedGroupControl(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addMessage(builder: flatbuffers.Builder, message: GroupControl) {
    builder.addFieldInt16(0, message, GroupControl.SEC);
  }

  static addValueType(builder: flatbuffers.Builder, valueType: Value) {
    builder.addFieldInt8(1, valueType, Value.NONE);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, valueOffset, 0);
  }

  static endValuedGroupControl(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createValuedGroupControl(
    builder: flatbuffers.Builder,
    message: GroupControl,
    valueType: Value,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ValuedGroupControl.startValuedGroupControl(builder);
    ValuedGroupControl.addMessage(builder, message);
    ValuedGroupControl.addValueType(builder, valueType);
    ValuedGroupControl.addValue(builder, valueOffset);
    return ValuedGroupControl.endValuedGroupControl(builder);
  }

  unpack(): ValuedGroupControlT {
    return new ValuedGroupControlT(
      this.message(),
      this.valueType(),
      (() => {
        const temp = unionToValue(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ValuedGroupControlT): void {
    _o.message = this.message();
    _o.valueType = this.valueType();
    _o.value = (() => {
      const temp = unionToValue(this.valueType(), this.value.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ValuedGroupControlT {
    const t = new ValuedGroupControlT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("value_type")) {
      t.valueType = this.valueType();
    }
    if (fieldSet.has("value")) {
      t.value = (() => {
        const temp = unionToValue(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ValuedGroupControlT implements flatbuffers.IGeneratedObject {
  constructor(
    public message: GroupControl = GroupControl.SEC,
    public valueType: Value = Value.NONE,
    public value:
      | BoolValueT
      | ByteValueT
      | DoubleValueT
      | FloatValueT
      | IntValueT
      | LongValueT
      | ShortValueT
      | StringValueT
      | UByteValueT
      | UIntValueT
      | ULongValueT
      | UShortValueT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const value = builder.createObjectOffset(this.value);

    return ValuedGroupControl.createValuedGroupControl(
      builder,
      this.message,
      this.valueType,
      value,
    );
  }

  clone(): ValuedGroupControlT {
    const obj = new ValuedGroupControlT();
    obj.message = this.message;
    obj.valueType = this.valueType;
    obj.value =
      this.value !== null && typeof (this.value as any).clone === "function"
        ? (this.value as any).clone()
        : this.value;
    return obj;
  }

  equals(other: ValuedGroupControlT): boolean {
    if (this.message !== other.message) return false;
    if (this.valueType !== other.valueType) return false;
    if (this.value !== null && other.value !== null) {
      if (typeof (this.value as any).equals === "function") {
        if (!(this.value as any).equals(other.value)) return false;
      } else if (this.value !== other.value) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyValuedGroupControl(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "value");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // BoolValue
            {
              const o = verifier.readInt32(pos);
              verifyBoolValue(verifier, pos + o);
            }
            break;
          case 2: // ByteValue
            {
              const o = verifier.readInt32(pos);
              verifyByteValue(verifier, pos + o);
            }
            break;
          case 3: // UByteValue
            {
              const o = verifier.readInt32(pos);
              verifyUByteValue(verifier, pos + o);
            }
            break;
          case 4: // ShortValue
            {
              const o = verifier.readInt32(pos);
              verifyShortValue(verifier, pos + o);
            }
            break;
          case 5: // UShortValue
            {
              const o = verifier.readInt32(pos);
              verifyUShortValue(verifier, pos + o);
            }
            break;
          case 6: // IntValue
            {
              const o = verifier.readInt32(pos);
              verifyIntValue(verifier, pos + o);
            }
            break;
          case 7: // UIntValue
            {
              const o = verifier.readInt32(pos);
              verifyUIntValue(verifier, pos + o);
            }
            break;
          case 8: // LongValue
            {
              const o = verifier.readInt32(pos);
              verifyLongValue(verifier, pos + o);
            }
            break;
          case 9: // ULongValue
            {
              const o = verifier.readInt32(pos);
              verifyULongValue(verifier, pos + o);
            }
            break;
          case 10: // FloatValue
            {
              const o = verifier.readInt32(pos);
              verifyFloatValue(verifier, pos + o);
            }
            break;
          case 11: // DoubleValue
            {
              const o = verifier.readInt32(pos);
              verifyDoubleValue(verifier, pos + o);
            }
            break;
          case 12: // StringValue
            {
              const o = verifier.readInt32(pos);
              verifyStringValue(verifier, pos + o);
            }
            break;
        }
      }
    }
  } finally {
    verifier.popDepth();
  }
}
